// ============================================================================
// CabinetOrdersTab.tsx — вкладка «Заявки» кабинета.
//
// Реальный список заявок на существующих RPC (OrderService.ListOrders): тот же
// AutoListForm, что в «Предприятии» (вид/колонки/поиск/отборы/группировки),
// открытие записи — существующей AutoObjectForm. Сервер сам ограничивает
// выборку правами и полномочиями — клиент ничего не подменяет.
// ============================================================================

import { CabinetTypeListTab } from './CabinetTypeListTab';

export function CabinetOrdersTab() {
  return (
    <CabinetTypeListTab
      kind="order"
      emptyText="Типы заявок не настроены. Создайте тип заявки в конфигураторе — заявки появятся здесь."
    />
  );
}
